export const FORM_TYPE = {
  single: "single",
  multipleFromFiles: "multipleFromFiles",
};
